import { Component } from '@angular/core';

@Component({
    selector: 'payments-description-list-column',
    template: '<ng-content></ng-content>',
    styleUrls: ['./description-list-column.component.scss'],
    standalone: false
})
export class DescriptionListColumnComponent {}
